// extracted by mini-css-extract-plugin
export var feature = "feature-module--feature--GBJBu";
export var feature__content = "feature-module--feature__content--FlpBD";
export var feature__title = "feature-module--feature__title--31hMZ";
export var feature__desc = "feature-module--feature__desc--MBIxh";
export var feature__listItem = "feature-module--feature__list-item--3fs-Y";
export var feature__button = "feature-module--feature__button--7EJkg";
export var feature__video = "feature-module--feature__video--ys8Ef";
export var feature__background = "feature-module--feature__background--3Ih8o";